import React, { FunctionComponent, useState } from "react";
import { Loader } from "../../../../UI/Loaders/Loaders";
import RequestsErrorMessage from "../../components/RequestsErrorMessage";
import RequestsAlert from "../../components/RequestsAlert";
import RequestsInfo from "../../components/RequestsInfo";
import RequestsSearchAndSizeControls from "../../components/RequestsSearchAndSizeControls";
import Paginator from "../../../Pagination/Pagination.component";
import { connect } from "react-redux";
import { hideModal, showModal } from "../../../../redux/actions/modal";
import {
  usePendingAdminWalletTopUpsRequests,
  usePendingAdminWalletWithdrawalRequests,
} from "../../../../custom-hooks/usePendingAdminWalletRequests";
import WithdrawalRequestsDataTable from "../../components/WithdrawalRequestsDataTable";
import WalletWithdrawalDataTable from "../../components/WalletWithdrawalDataTable";
import WalletTopUpDataTable from "../../components/WalletTopUpDataTable";

const AdminWalletTopUp: FunctionComponent = (props: any) => {
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [size, setSize] = useState<number>(20);
  const [searchValue, setSearchValue] = useState<string>("");
  const {
    data: pendingAdminWalletTopUps,
    status,
    error,
  } = usePendingAdminWalletTopUpsRequests();

  const renderContent = (): JSX.Element | null => {
    switch (status) {
      case "loading":
        return <Loader centered={true} text="Loading top up requests..." />;
      case "error":
        return (
          <RequestsErrorMessage message="There was an issue while fetching pending top up requests, Please Reload The Page" />
        );
      case "success":
        if (
          !pendingAdminWalletTopUps ||
          pendingAdminWalletTopUps.length === 0
        ) {
          return (
            <RequestsErrorMessage message="There are currently no pending top up requests." />
          );
        }
        return (
          <WalletTopUpDataTable
            data={pendingAdminWalletTopUps}
            showModal={props.showModal}
            hideModal={props.hideModal}
            initiator="admin"
          />
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <RequestsAlert />
      {status !== "loading" && (
        <div className="d-flex justify-content-between">
          <RequestsInfo />
          <RequestsSearchAndSizeControls
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            size={size}
            onSizeChange={setSize}
          />
        </div>
      )}
      {renderContent()}
      <Paginator
        size={size}
        page={pageNumber}
        count={pendingAdminWalletTopUps ? pendingAdminWalletTopUps.length : 0}
        changeCurrentPage={setPageNumber}
      />
    </div>
  );
};

export default connect(null, { showModal, hideModal })(AdminWalletTopUp);
